import { render, staticRenderFns } from "./channelList.vue?vue&type=template&id=d6f5b7d0&scoped=true"
import script from "./channelList.vue?vue&type=script&lang=js"
export * from "./channelList.vue?vue&type=script&lang=js"
import style0 from "./channelList.vue?vue&type=style&index=0&id=d6f5b7d0&prod&scoped=true&lang=less"
import style1 from "./channelList.vue?vue&type=style&index=1&id=d6f5b7d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f5b7d0",
  null
  
)

export default component.exports